let fileUploadTemplate,
	basicMenuTemplate,
	mailMenuTemplate,
	calendarReminderMenuTemplate,
	clientOverviewEmailTemplate;

function insertHtml(qtvar) {
	let template = '%var%';
	template = template.replace(/%var%/g, qtvar);
	if (this.$editor()) {
		this.$editor().displayElements.text.trigger('focus');
		this.$editor().wrapSelection('inserthtml', template, true);
	}
}

export const insertList = {
	InsertClientName: '%client_name%',
	InsertInvoiceDueDate: '%payment_due_date%',
	InsertInvoiceAmount: '%payment_amount%',
	InsertCompanyName: '%business_name%',
	InsertCompanyPhone: '%company_phone%',
	InsertCompanyEmail: '%company_email%',
	InsertClientSurname: '%client_surname%',
	InsertClientPhone: '%client_phone%',
	InsertClientAddress: '%client_address%',
	InsertClientEmail: '%client_email%',
	InsertClientNotes: '%client_notes%',
	InsertJobName: '$jobName$',
	InsertJobDate: '%job_date%',
	InsertJobTime: '%job_time%',
	InsertJobLocation: '%job_location%',
	InsertJobNotes: '%job_notes%',
	InsertAppointmentDate: '%appointment_date%',
	InsertAppointmentTime: '%appointment_time%',
	InsertContractLink:
		'<p><span><a target="_blank" href="%contract_link%">Please view and sign your contract online by clicking here</a></span></p>',
	InsertInvoiceLink:
		'<p><span><a target="_blank" href="%invoice_link%">Please click here to view and pay your invoice online</a></span></p>',
	InsertQuoteLink:
		'<p><span><a target="_blank" href="%quote_link%">Please view your quote online by clicking here</a></span></p>',
	InsertQuestionnaireLink:
		'<p><span><a target="_blank" href="%questionnaire_link%">Please view the questionnaire online by clicking here</a></span></p>',
	InsertGalleriesLink:
		'<p><span><a target="_blank" href="%galleries_link%">Please view the galleries online by clicking here</a></span></p>'
};

function insertVariable(variable) {
	insertHtml.call(this, insertList[variable], true);
}

fileUploadTemplate =
	'<div class="dropdown insert-var-container" unselectable="on" disabled="disabled">';
fileUploadTemplate +=
	'<button type="button" class="btn btn-default dropdown-toggle" name="attachment_fiels" ' +
	'tabindex="-1" on-click="executeAction($event)"' +
	'ng-class="displayActiveToolClass(active)" data-toggle="dropdown" title="Attachment files" ' +
	'unselectable="on" disabled="disabled"><i class="fa fa-paperclip"></i></button>';
fileUploadTemplate += '<ul class="dropdown-menu no-overflow">';
fileUploadTemplate +=
	'<li><a class="showfiles" ng-click="showFilesModal()">From Files</a></li>';
fileUploadTemplate +=
	'<li><a ng-click="uploadFromComputer()">From Computer</a></li>';
fileUploadTemplate += '</ul>';
fileUploadTemplate += '</div>';

export const fileUpload = {
	menu: fileUploadTemplate,
	methods: insertVariable
};

basicMenuTemplate =
	'<div class="dropdown insert-var-container" unselectable="on" disabled="disabled">';
basicMenuTemplate +=
	'<button class="btn btn-default dropdown-toggle" unselectable="on" ng-class="displayActiveToolClass(active)" on-click="executeAction($event)" tabindex="-1" data-toggle="dropdown">';
basicMenuTemplate += 'Insert variable<span class="caret"></span>';
basicMenuTemplate += '</button>';
basicMenuTemplate += '<ul class="dropdown-menu no-overflow">';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertCompanyName\')">Business Name</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertCompanyPhone\')">Business Phone</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertCompanyEmail\')">Business Email</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertInvoiceDueDate\')">Payment due date</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertInvoiceAmount\')">Payment amount</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientName\')">Сlient name</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientSurname\')">Client Surname</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientPhone\')">Client Phone</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientEmail\')">Client Email</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientAddress\')">Client Address</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientNotes\')">Client Notes</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertJobName\')">Lead/Job Name</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertJobDate\')">Lead/Job Date</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertJobTime\')">Lead/Job Time</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertJobLocation\')">Lead/Job Location</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertJobNotes\')">Lead/Job Notes</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertQuoteLink\')">Quote Link</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertInvoiceLink\')">Invoice Link</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertContractLink\')">Contract Link</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertQuestionnaireLink\')">Questionnaire Link</a></li>';
basicMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertGalleriesLink\')">Galleries Link</a></li>';
basicMenuTemplate += '</ul>';
basicMenuTemplate += '</div>';

export const basicMenu = {
	menu: basicMenuTemplate,
	methods: insertVariable
};

mailMenuTemplate = '<div class="dropdown insert-var-container">';
mailMenuTemplate +=
	'<button class="btn btn-default dropdown-toggle" data-toggle="dropdown" >';
mailMenuTemplate += 'Insert variable<span class="caret"></span>';
mailMenuTemplate += '</button>';
mailMenuTemplate += '<ul class="dropdown-menu no-overflow">';
mailMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertCompanyName\')">Business Name</a></li>';
mailMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertCompanyPhone\')">Business Phone</a></li>';
mailMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertCompanyEmail\')">Business Email</a></li>';
mailMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientName\')">Сlient name</a></li>';
mailMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientSurname\')">Client Surname</a></li>';
mailMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientPhone\')">Client Phone</a></li>';
mailMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientEmail\')">Client Email</a></li>';
mailMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientAddress\')">Client Address</a></li>';
mailMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientNotes\')">Client Notes</a></li>';
mailMenuTemplate += '</ul>';
mailMenuTemplate += '</div>';

export const mailMenu = {
	menu: mailMenuTemplate,
	methods: insertVariable
};

calendarReminderMenuTemplate =
	'<div class="dropdown insert-var-container" style="padding:0;">';
calendarReminderMenuTemplate +=
	'<button class="btn btn-default dropdown-toggle" style="border-radius-left" data-toggle="dropdown" ng-mouseup="focusHack()">';
calendarReminderMenuTemplate += 'Insert variable<span class="caret"></span>';
calendarReminderMenuTemplate += '</button>';
calendarReminderMenuTemplate += '<ul class="dropdown-menu no-overflow">';
calendarReminderMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertCompanyName\')">Business Name</a></li>';
calendarReminderMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertCompanyPhone\')">Business Phone</a></li>';
calendarReminderMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertCompanyEmail\')">Business Email</a></li>';
calendarReminderMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientName\')">Сlient name</a></li>';
calendarReminderMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientSurname\')">Client Surname</a></li>';
calendarReminderMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientPhone\')">Client Phone</a></li>';
calendarReminderMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientEmail\')">Client Email</a></li>';
calendarReminderMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientAddress\')">Client Address</a></li>';
calendarReminderMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientNotes\')">Client Notes</a></li>';
calendarReminderMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertAppointmentDate\')">Appointment Date</a></li>';
calendarReminderMenuTemplate +=
	'<li><a ng-click="insertVariable(\'InsertAppointmentTime\')">Appointment Time</a></li>';
calendarReminderMenuTemplate += '</ul>';
calendarReminderMenuTemplate += '</div>';

export const calendarReminderMenu = {
	menu: calendarReminderMenuTemplate,
	methods: insertVariable
};

clientOverviewEmailTemplate =
	'<div class="dropdown insert-var-container" unselectable="on" disabled="disabled">';
clientOverviewEmailTemplate +=
	'<button class="btn btn-default dropdown-toggle" unselectable="on" ng-class="displayActiveToolClass(active)" on-click="executeAction($event)" tabindex="-1" data-toggle="dropdown">';
clientOverviewEmailTemplate += 'Insert variable<span class="caret"></span>';
clientOverviewEmailTemplate += '</button>';
clientOverviewEmailTemplate += '<ul class="dropdown-menu no-overflow">';
clientOverviewEmailTemplate +=
	'<li><a ng-click="insertVariable(\'InsertCompanyName\')">Business Name</a></li>';
clientOverviewEmailTemplate +=
	'<li><a ng-click="insertVariable(\'InsertCompanyPhone\')">Business Phone</a></li>';
clientOverviewEmailTemplate +=
	'<li><a ng-click="insertVariable(\'InsertCompanyEmail\')">Business Email</a></li>';
clientOverviewEmailTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientName\')">Сlient name</a></li>';
clientOverviewEmailTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientSurname\')">Client Surname</a></li>';
clientOverviewEmailTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientPhone\')">Client Phone</a></li>';
clientOverviewEmailTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientEmail\')">Client Email</a></li>';
clientOverviewEmailTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientAddress\')">Client Address</a></li>';
clientOverviewEmailTemplate +=
	'<li><a ng-click="insertVariable(\'InsertClientNotes\')">Client Notes</a></li>';
clientOverviewEmailTemplate += '</ul>';
clientOverviewEmailTemplate += '</div>';

export const clientOverviewMailMenu = {
	menu: clientOverviewEmailTemplate,
	methods: insertVariable
};



// WEBPACK FOOTER //
// ./web/js/helper/rich_text_tokens.js